import { render } from "./StackingPools.vue?vue&type=template&id=dccc08d8&scoped=true"
import script from "./StackingPools.vue?vue&type=script&lang=js"
export * from "./StackingPools.vue?vue&type=script&lang=js"

import "./StackingPools.vue?vue&type=style&index=0&id=dccc08d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dccc08d8"]])

export default __exports__